import { HTMLProps } from '@/lib/util/types';
import { PropsWithChildren } from 'react';
import styles from './TagList.module.scss';

export type TagListProps = {} & HTMLProps<HTMLDivElement>;

const TagList: React.FC<PropsWithChildren<TagListProps>> = ({ children, ...props }) => {
  return (
    <div className={styles.tagList} {...props}>
      {children}
    </div>
  );
};

export default TagList;
